"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.bufferToString = exports.base64URL = void 0;var _encBase = _interopRequireDefault(require("crypto-js/enc-base64"));

/* istanbul ignore next */
const base64URL = (val) => {
  return val
  /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
  // @ts-ignore
  .toString(_encBase.default).
  replace(/=/g, '').
  replace(/\+/g, '-').
  replace(/\//g, '_');
};

/* istanbul ignore next */exports.base64URL = base64URL;
const bufferToString = (buffer) => {
  const CHARSET =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const state = [];
  for (let i = 0; i < buffer.byteLength; i += 1) {
    const index = buffer[i] % CHARSET.length;
    state.push(CHARSET[index]);
  }
  return state.join('');
};exports.bufferToString = bufferToString;